// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"powerstream_productcontent__rvejO"};